export { default } from './Term';
